import { ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { Component } from '@angular/core';
import { _HttpClient } from '@delon/theme';

@Component({
    selector: 'app-paypwd',
    templateUrl: './paypwd.component.html',
    styleUrls: ['./paypwd.cpmponent.less'],
})

// 付款密码框 组件
export class PayPwdComponent implements OnInit {
    constructor(
        private eleRef: ElementRef,
    ) {

    }

    @Output() input: EventEmitter<any> = new EventEmitter<any>();

    // pwd = {
    //     number0: '',
    //     number1: '',
    //     number2: '',
    //     number3: '',
    //     number4: '',
    //     number5: '',
    //     use: '',
    // }

    password = '';
    passwordArr = ['', '', '', '', '', ''];

    // readonly = [false, false, false, false, false, false];

    // pwdNowIndex = 0;

    focusStatus = false;



    // change(e, index): void {
    //     this.pwd.use = this.pwd.number0 + this.pwd.number1 + this.pwd.number2 + this.pwd.number3 + this.pwd.number4 + this.pwd.number5;
    //     // this.focus[index] = true;
    //     this.readonly[index] = true;
    //     this.pwdNowIndex = index + 1;
    //     if (this.pwdNowIndex > 5) {
    //         this.pwdNowIndex = 5;
    //     }
    //     this.eleRef.nativeElement.querySelector('.number' + (this.pwdNowIndex)).focus();
    //     if (this.pwd.use.length == 6) {
    //         this.input.emit(this.pwd.use);
    //     }

    //     console.log('change触发' + this.pwdNowIndex)


    // }

    // ngOnInit(): void {
    //     this.eventManager.addGlobalEventListener('window', 'keyup.backspace', () => {
    //         console.log('密码回退一位')
    //         this.pwd[this.pwdNowIndex] = '';
    //         this.readonly[this.pwdNowIndex - 1] = false;
    //         this.eleRef.nativeElement.querySelector('.number' + (this.pwdNowIndex - 1)).focus();
    //         this.pwdNowIndex -= 1;
    //         if (this.pwdNowIndex < 0) {
    //             this.pwdNowIndex = 0;
    //         }
    //         console.log('按键触发' + this.pwdNowIndex)
    //     });
    // }
    blur(): void {
        this.focusStatus = false;
    }
    change(e): void {
        this.password = e;
        this.passwordArr = e.split('');
        this.input.emit(this.password);
    }

    reset():void{
        this.password = '';
    }

    foucsFun(): void {
        this.eleRef.nativeElement.querySelector('.paypwdInput').focus();
        this.focusStatus = true;
    }

    ngOnInit(): void {

    }
}

